import { render } from "./MyCompany.vue?vue&type=template&id=860a28f6"
import script from "./MyCompany.vue?vue&type=script&lang=js"
export * from "./MyCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__